import { Link } from 'react-router'
import { TrustGauge } from '@carouselgg/nexus/trust-gauge'
import { ChevronRight } from '@carouselgg/nexus/icon'
import type { GameTrustScore, TrustScore } from '@carouselgg/auth/types'
import { bestNextStep, gameShortName, isLagging } from './trustCopy'
import styles from './GameList.module.css'

/**
 * Every game's score in one list — rows, not cards, so seven games read as
 * easily as two. Each row says where the game stands and the one thing that
 * would raise it most, and opens that game's page.
 */
export function GameList({ games, overall }: { games: GameTrustScore[]; overall: TrustScore }) {
  return (
    <ul className={styles.list} aria-label="Your game scores">
      {games.map((g) => {
        const lagging = isLagging(g, overall)
        const step = bestNextStep(g.score)
        const short = gameShortName(g)
        return (
          <li key={g.game_id}>
            <Link to={`/trust/${g.game_slug}`} className={styles.row}>
              {g.game_logo_url
                ? <img src={g.game_logo_url} alt="" className={styles.logo} />
                : <span className={styles.logoText} aria-hidden="true">{short}</span>}
              <span className={styles.text}>
                <span className={styles.name}>{g.game_name}</span>
                <span className={styles.meta}>
                  {g.score.level}
                  {lagging && <> · <span className={styles.lagging}>behind your overall</span></>}
                </span>
              </span>
              <TrustGauge
                score={g.score.score}
                size={40}
                title={`${g.game_name} score: ${g.score.score}`}
              />
              <span className={styles.step}>
                {step && <>{step.label} <b>+{step.points}</b></>}
              </span>
              <ChevronRight size={16} className={styles.chevron} aria-hidden="true" />
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
